module.exports = __webpack_public_path__ + "img/130.d861e812.svg";